import { Pipe, PipeTransform } from '@angular/core';
import { E } from '@macs-frontend/core/utils/fp-ts';

@Pipe({ name: 'isRight', pure: true })
export class IsRightPipe implements PipeTransform {
  public transform<T>(value: E.Either<unknown, T>): value is E.Right<T> {
    return E.isRight(value);
  }
}
